// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue';
import App from './App';
import router from './router';
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css'
import "babel-polyfill"
import VueBus from 'vue-bus';

import mixin from './share'
Vue.mixin(mixin)
Vue.use(VueBus);
Vue.use(ElementUI)

Vue.config.productionTip = false;
import vuex from 'vuex'
Vue.use(vuex);
var store = new vuex.Store({//store对象
    state:{
        //存放组件之间共享的数据
        basicShow:false,
        eduListShow:false,
        eduInfoShow:false,
        expListShow:false,
        expInfoShow:false,
        proListShow:false,
        proInfoShow:false,
        awaListShow:false,
        awaInfoShow:false,
        mainShow:false
    },
    mutations:{
        //显式的更改state里的数据
        changeBasic:function(state,a){
            state.basicShow = a;
        },
        changeEduList:function(state,a){
            state.eduListShow = a;
        },
        changeEduInfo:function(state,a){
            state.eduInfoShow = a;
        },
        changeExpList:function(state,a){
            state.expListShow = a;
        },
        changeExpInfo:function(state,a){
            state.expInfoShow = a;
        },
        changeProList:function(state,a){
            state.proListShow = a;
        },
        changeProInfo:function(state,a){
            state.proInfoShow = a;
        },
        changeAwaList:function(state,a){
            state.awaListShow = a;
        },
        changeAwaInfo:function(state,a){
            state.awaInfoShow = a;
        },
        changeMain:function(state,a){
            state.mainShow = a;
        },
    },
    getters:{

    },
})
/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  store,
  template: '<App/>',
  components: { App }
});
import { MessageBox } from 'mint-ui';
router.beforeEach((to, from, next) =>{
    if(store.state.mainShow){
        localStorage.setItem('jumpUrl',false)
        store.commit('changeMain',false)

        MessageBox.close();
        next(false)
    } else{
        next()
    }
})


// WEBPACK FOOTER //
// ./src/modules/index/index.js